import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/Button';
import { Card } from '../ui/Card';
import { Rating } from '../ui/Rating';
import { AnimatedSection, staggerContainer, staggerItem } from './AnimatedSection';
import { topAstrologers } from './homeData';
interface TopAstrologersSectionProps {
  onNavigate: (page: string) => void;
}
export function TopAstrologersSection({
  onNavigate
}: TopAstrologersSectionProps) {
  return <AnimatedSection className="py-8 sm:py-24 bg-white overflow-hidden" data-id="element-17213">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17214">
        <div className="flex justify-between items-end mb-4 sm:mb-12" data-id="element-17215">
          <div data-id="element-17216">
            <h2 className="text-lg sm:text-3xl font-bold text-slate-900 mb-1 sm:mb-3" data-id="element-17217">
              Топ астрологи
            </h2>
            <p className="text-xs sm:text-lg text-slate-500" data-id="element-17218">
              Проверенные эксперты с высоким рейтингом
            </p>
          </div>
          <Button variant="ghost" className="hidden sm:flex text-slate-500" onClick={() => onNavigate('astrologers')} data-id="element-17219">
            Смотреть всех <ArrowRight className="ml-2 w-4 h-4" data-id="element-17220" />
          </Button>
        </div>

        {/* Mobile: horizontal scroll */}
        <div className="sm:hidden flex gap-3 overflow-x-auto pb-2 -mx-4 px-4 snap-x snap-mandatory" style={{
        scrollbarWidth: 'none'
      }} data-id="element-17221">
          {topAstrologers.map(a => <div key={a.id} className="flex-shrink-0 w-[160px] snap-center bg-white rounded-xl border border-slate-100 p-3 text-center" data-id="element-17222">
              <div className={`w-12 h-12 rounded-full ${a.color} flex items-center justify-center text-sm font-bold mx-auto mb-2`} data-id="element-17223">
                {a.name.split(' ').map(n => n[0]).join('')}
              </div>
              <h3 className="font-bold text-slate-900 text-xs mb-0.5" data-id="element-17224">
                {a.name}
              </h3>
              <p className="text-[10px] text-slate-500 mb-1.5" data-id="element-17225">{a.spec}</p>
              <div className="text-[10px] text-amber-500 font-bold mb-2" data-id="element-17226">
                ★ {a.rating} ({a.reviews})
              </div>
              <Button variant="outline" size="sm" fullWidth className="!text-[10px] !py-1" onClick={() => onNavigate('astrologer-profile')} data-id="element-17227">
                Профиль
              </Button>
            </div>)}
        </div>

        {/* Desktop: grid */}
        <motion.div className="hidden sm:grid sm:grid-cols-2 lg:grid-cols-4 gap-6" variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} data-id="element-17228">
          {topAstrologers.map(a => <motion.div key={a.id} variants={staggerItem} data-id="element-17229">
              <Card hoverable className="text-center border-slate-100 h-full" data-id="element-17230">
                <div className="relative inline-block mb-4" data-id="element-17231">
                  <div className={`w-20 h-20 rounded-full ${a.color} flex items-center justify-center text-xl font-bold mx-auto`} data-id="element-17232">
                    {a.name.split(' ').map(n => n[0]).join('')}
                  </div>
                </div>
                <h3 className="font-bold text-slate-900 mb-0.5" data-id="element-17233">{a.name}</h3>
                <p className="text-sm text-slate-500 mb-3" data-id="element-17234">{a.spec}</p>
                <Rating value={a.rating} count={a.reviews} size="sm" className="justify-center mb-4" data-id="element-17235" />
                <Button variant="outline" size="sm" fullWidth onClick={() => onNavigate('astrologer-profile')} data-id="element-17236">
                  Профиль
                </Button>
              </Card>
            </motion.div>)}
        </motion.div>
      </div>
    </AnimatedSection>;
}